export default function BidEnvelopeIcon() {
  return (
    <>
      <div className="social_media_icon">
        <a href="mailto:support@bidfta.com" target="_blank" rel="noreferrer">
          <svg
            width="21"
            height="15"
            viewBox="0 0 21 15"
            fill="#FECE62"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.796867 13.0535C0.735768 12.8563 0.704743 12.651 0.704834 12.4445V2.59321C0.704733 2.36372 0.743105 2.13582 0.818361 1.91896L6.91432 7.47652L0.796867 13.0535ZM20.1174 13.8854C19.9243 14.0855 19.6928 14.2448 19.4366 14.3536C19.1805 14.4625 18.905 14.5187 18.6266 14.5189H2.78279C2.24865 14.5187 1.7353 14.3123 1.35007 13.943L7.67871 8.17337L10.0123 10.3011C10.5812 10.7618 10.9704 10.788 11.5663 10.2937L13.8689 8.18892L20.1174 13.8854ZM20.6223 2.01629C20.6772 2.20371 20.7049 2.39797 20.7048 2.59321V12.4445C20.7049 12.6162 20.6834 12.7872 20.6409 12.9536L14.6485 7.47652L20.6223 2.01629ZM2.78308 0.518921H18.6266C19.1672 0.519142 19.6864 0.730439 20.073 1.10765L10.7654 9.59329L1.39624 1.05207C1.77638 0.709257 2.27046 0.519432 2.78279 0.519352L2.78308 0.518921Z"
            />
          </svg>
        </a>
      </div>
    </>
  )
}
